module.exports = __webpack_public_path__ + "img/202411_05.93409584.jpg";